// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__Vey_q","cell":"ColumnAccessor_cell__2c0G0","firstCellAccent":"ColumnAccessor_firstCellAccent__3kN7g"};